// extracted by mini-css-extract-plugin
export default {"product-item":"ProductItem_product-item__4U82n","product-item-name":"ProductItem_product-item-name__yjtWZ","product-item-price":"ProductItem_product-item-price__F6Myf"};